import CommunicationToolsFilterModel from './communication-tool-filter/communication-tool-filter.model';

export default class CommunicationToolService {
  /* @ngInject */
  constructor(HttpService, CommunicationToolItem, CommunicationToolCollection) {
    this.httpService = HttpService;
    this.CommunicationToolItem = CommunicationToolItem;
    this.CommunicationToolCollection = CommunicationToolCollection;
    this.SERVICE = `${HttpService.BASE_PATH}/communication_tools`;
    this.AVAILABLE_SLUG = [
      'BREAKING_NEWS',
      'PRODUCT_CATALOGUES',
      'FENDI_AD_CAMPAIGNS',
      'FENDI_RUNWAY',
      'FENDI_VIDEOS',
      'FENDI_CELEBRITIES',
      'EDITORIALS',
    ];
  }

  getCategories(params = {}) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE}/categories`,
      params: {online: 1, ...params},
    }).then(({data}) => {
      return data.data
        .filter(tool => this.AVAILABLE_SLUG.includes(tool.slug))
        .sort((a, b) => this.AVAILABLE_SLUG.indexOf(a.slug) - this.AVAILABLE_SLUG.indexOf(b.slug));
    });
  }

  getCategory(categoryId) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE}/categories/${categoryId}?online=1`,
    }).then(({data}) => data.data, this.httpService.reject);
  }


  collections(categoryId, params) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE}/categories/${categoryId}/tools`,
      params,
    }).then(({data}) => {
      const collections = data.data.map(i => new this.CommunicationToolCollection(i));
      return {
        collections,
        page: data.page,
        perPage: data.perPage,
        total: data.total,
      };
    });
  }

  items(collectionId, params) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE}/tools/${collectionId}/items`,
      params,
    }).then(({data}) => {
      return {
        items: data.data.map(i => new this.CommunicationToolItem(i)),
        page: data.page,
        perPage: data.perPage,
        total: data.total,
      };
    });
  }

  item(itemId, params) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE}/items/${itemId}`,
      params,
    }).then(({data}) => {
      return new this.CommunicationToolItem(data.data);
    });
  }

  relatedToProduct(productId) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE}/items/products/${productId}?online=1`,
    }).then((response) => {
      return response.data.data.map(i => new this.CommunicationToolItem(i));
    });
  }

  getEditorialFilters(params = {}) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE}/tools/editorials_filters`,
      params: {
        online: 1,
        visible: 1,
        ...params,
      },
    }).then(data => new CommunicationToolsFilterModel(data.data.data), this.httpService.reject);
  }
}



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool.service.js